module.exports = __webpack_public_path__ + "static/gallery14-eff336a5b42cf987a074a12b461fb924.jpg";